import React, { useContext } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Sprout } from "lucide-react";
import AuthContext from "../../../contexts/AuthContext/AuthContext";
import { initials } from "../careUtils";
import { icon } from "../ui";
import "../careTeam.css";

// Header shared by every signed-in provider page.
const ProviderShell = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const name =
    [user?.first_name, user?.last_name].filter(Boolean).join(" ") || user?.username;

  const signOut = () => {
    logout();
    navigate("/provider/signin");
  };

  return (
    <div className="ct ct-provider">
      <nav className="ct-nav" aria-label="Provider">
        <Link to="/provider/patients" className="ct-nav__brand">
          <span className="ct-nav__brand-icon">{icon(Sprout, 22)}</span>
          MendGrove <span className="ct-kicker">Clinicians</span>
        </Link>
        <Link
          to="/provider/patients"
          className="ct-nav__link"
          aria-current={pathname.startsWith("/provider/patients") ? "page" : undefined}
        >
          Patients
        </Link>
        <Link to="/settings" className="ct-nav__link">
          Account
        </Link>
        <span className="ct-nav__me">
          <span className="ct-avatar" aria-hidden="true">
            {initials(name)}
          </span>
          {name}
        </span>
        <button type="button" className="ct-btn ct-btn--ghost" onClick={signOut}>
          Sign out
        </button>
      </nav>
      <Outlet />
    </div>
  );
};

export default ProviderShell;
